import React,{useEffect,useState,useCallback} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'

const pageSize = 5;

const TcTermsMain = () => {

  const[details, setDetails] =useState([])
  const[list,setList]= useState([])

  const[content, setContent] =useState([])
  const[delDetail, setdelDetail] =useState([])
  const[display, setDisplay] =useState(true)
  const[edit,setEdit]= useState(true)
const[del,setDel]= useState(true)
const[btn,setBtn]= useState(true)
  const[pop,setpop] = useState(false);

  const [allusers,setAllusers]= useState([])
  const [paginatedPosts, setpaginatedPosts] = useState([]);
  //const [currentPage, setcurrentPage] = useState(1);
  
  
  useEffect(()=>{
    setpop(true);
    GetTermscondition();
   // GetTcUserRole()
    //GetTcUserAllRole()
    GetTermsList()
  
    document.getElementById('Tc-sectionMain').style.display ="none";
    document.getElementById('TCtable').style.display ="none";
    document.getElementById('pagination').style.display ="none";
   
      setTimeout(()=>{
        setpop(false);
        document.getElementById('Tc-sectionMain').style.display ="flex";
        document.getElementById('TCtable').style.display ="flex";
        document.getElementById('pagination').style.display ="block";
        getRoleData()
        getUserRole();
     
      },1000)
  },[1])
     
  function GetTermscondition(){
     
      fetch('https://localhost:44312/Api/Tc/GetTcTermsCondition', {
       
      method:'GET',
    
        headers : {
    
          "Content-type": "application/json",
    
          "Accept": "application/json",
    
          "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
        },
    

  }).then(response => response.json())
  .then(data => {
  console.log("Data",data)
    setDetails(data)
     setAllusers(data)
        setpaginatedPosts(data);
    console.log(data)
    localStorage.setItem("TermsData", JSON.stringify(data));
 
  });
  
 
  }


  
  function myFunction() {

    // Create an "li" node:
    const node = document.createElement("li");
    
    var input = document.getElementById('listInput').value 
  
    // Create a text node:
    const textnode = document.createTextNode(input);
    
    
    // Append the text node to the "li" node:
    node.appendChild(textnode);

    // Append the "li" node to the list:
    document.getElementById("myList").appendChild(node);
    document.getElementById('listInput').value='*'

    

    }
    

 
function handlechange(){
  var HeadingInputA = document.getElementById("headinputA").value
  var HeadingInputB = document.getElementById("headinputB").value
  var ContentInput =  document.getElementById("contentinput").value
  var listContent = document.getElementById("myList").innerText
  //listContent.split(/(?=[A-Z])/))
   if(!HeadingInputA){
    document.getElementById('HeadingAError').innerHTML = "Heading Required";
   }
  else{
    document.getElementById('HeadingAError').innerHTML = "";
  }
  
  if(!ContentInput){
    document.getElementById('HeadingBError').innerHTML = "Content Required";
  }
  else{
    document.getElementById('HeadingBError').innerHTML =""
  
}
}

  function AddTcTermsCondition(){
     

    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   
    

    var HeadingInputA = document.getElementById("headinputA").value
    var HeadingInputB = document.getElementById("headinputB").value
    var ContentInput =  document.getElementById("contentinput").value
    var listContent = document.getElementById("myList").innerText
    //listContent.split(/(?=[A-Z])/))
     if(!HeadingInputA){
      document.getElementById('HeadingAError').innerHTML = "Heading Required";
     }
    else{
      document.getElementById('HeadingAError').innerHTML = "";
    }
    

    // if (HeadingInputB==""){
    //   HeadingInputB="null"
    // }
    
    if(!ContentInput){
      document.getElementById('HeadingBError').innerHTML = "Content Required";
    }
    else{
      document.getElementById('HeadingBError').innerHTML =""
    
            const body ={

              heading4: HeadingInputA,
              heading5: HeadingInputB,
             content: ContentInput,
             createdBy: "123",
             listcontent: listContent

            }
             console.log(body)
              axios({
             
              method:"POST",
               //url: `${BASE_URL}/Tc/TcUserAddress`,
             url:"https://localhost:44312/Api/Tc/AddTcTermsCondition",
             data:body,
             headers: {
             "Content-Type" : "application/json",
             'Authorization':bearer
             }
      
              })
              .then((response) =>{
              console.log(response.data);

              GetTermscondition()
              GetTermsList()
       
              if(response.data.status=='Success'){
                document.getElementById('success-notify').style.display = "block"
                 setTimeout(()=>{
                   document.getElementById('success-notify').style.display = "none"
                 },1000)
              }
               document.getElementById("headinputA").value = ""
               document.getElementById("headinputB").value = ""
      document.getElementById("contentinput").value = "" 
      document.getElementById('listInput').value = "" 
      document.getElementById("myList").innerText=null
             
              })
              .catch(error => {
                console.log(error);
             
              document.getElementById('error-notify').style.display = "block"
               setTimeout(()=>{
                 document.getElementById('error-notify').style.display = "none"
               },1000)
           
           
              })
            } 
          }


            function getEditContent(Id){

              let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
              
              document.getElementById("tcContenteditForm").style.display = "block";
            
             const body ={
              
              id:Id
            
             }
             console.log(body);
            
            
              axios({          
                 method: "POST", 
                 //url: `${BASE_URL}/Tc/EditSection`,      
                 url: "https://localhost:44312/Api/Tc/EditTcTermsCondition",
                 data:body,
                 headers: {             
                   'Content-Type': 'application/json' , 
                   'Authorization':bearer     
                 }
               
               })
               .then((response) =>{
                console.log(response.data);
                setContent(response.data)
            
                 }) 
                          
            } 


function closeContentEditForm(){

document.getElementById("tcContenteditForm").style.display = "none";
document.getElementById("contentreset").reset();
document.getElementById("UpdateSecErrA").innerHTML = ""
document.getElementById("UpdateSecErrC").innerHTML =""
}

function handleTermschange(){

  var HeadingInputA = document.getElementById("editInputA").value

    var ContentInput =  document.getElementById("editInputC").value
   

    if(!HeadingInputA){
      document.getElementById("UpdateSecErrA").innerHTML = "Heading Required"
    }
    else{
      document.getElementById("UpdateSecErrA").innerHTML = ""
    }
    if(!ContentInput){
      document.getElementById("UpdateSecErrC").innerHTML = "Content Required"
      
    }

    else{
      document.getElementById("UpdateSecErrC").innerHTML =""
}
}

function updateContent(Id){

  var HeadingInputA = document.getElementById("editInputA").value
  var HeadingInputB = document.getElementById("editInputB").value
    var ContentInput =  document.getElementById("editInputC").value
    var ListInput =  document.getElementById("editInputD").value

    if(!HeadingInputA){
      document.getElementById("UpdateSecErrA").innerHTML = "Heading Required"
    }
    else if(!ContentInput){
      document.getElementById("UpdateSecErrC").innerHTML = "Content Required"
      document.getElementById("UpdateSecErrA").innerHTML = ""
    }

    else{
      document.getElementById("UpdateSecErrC").innerHTML =""
    
            const body ={

              heading4: HeadingInputA,
              heading: HeadingInputB,
             content: ContentInput,
                 id:Id,
               editedBy:"1234",
               listcontent:ListInput
  
   }
   console.log(body);
  
   let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    axios({          
       method: "POST", 
       //url: `${BASE_URL}/Tc/EditSection`,      
       url: "https://localhost:44312/Api/Tc/UpdateTcTermsCondition",
       data:body,
       headers: {             
         'Content-Type': 'application/json', 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      closeContentEditForm()
      if(response.data.status=='Success'){
        document.getElementById('edit-notify').style.display = "block"
         setTimeout(()=>{
           document.getElementById('edit-notify').style.display = "none"
         },1000)
      }
    
     GetTermscondition();
     GetTermsList()
       }) 
      }
}

function delContent(Id){
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
 
  const body ={
    id:Id
  }
   console.log(body)
    axios({
   
    method:"POST",
     //url: `${BASE_URL}/Tc/Sectiondelete`,
   url:"https://localhost:44312/Api/Tc/DeleteTcTerms",
   data:body,
   headers: {
   "Content-Type" : "application/json",
   'Authorization':bearer
   }
    })
    .then((response) =>{
    console.log(response.data);
 
    GetTermscondition()
    document.getElementById("modalDeleteForm").style.display = "none";

    if(response.data.status=='Success'){
      document.getElementById('del-notify').style.display = "block"
       setTimeout(()=>{
         document.getElementById('del-notify').style.display = "none"
       },1000)
    }
    })
}         
  
function ConfirmDelete(Id){

  document.getElementById("modalDeleteForm").style.display = "block";
  getDetails(Id)

}
 

function getDetails(Id){

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  
 const body ={
  
  id:Id

 }
 console.log(body);


  axios({          
     method: "POST", 
     //url: `${BASE_URL}/Tc/EditSection`,      
     url: "https://localhost:44312/Api/Tc/GetTcTerms",
     data:body,
     headers: {             
       'Content-Type': 'application/json' , 
       'Authorization':bearer     
     }
   
   })
   .then((response) =>{
    console.log(response.data);
    setdelDetail(response.data)

     }) 

} 
function closedelForm()
{
   document.getElementById("modalDeleteForm").style.display = "none";
 
 }


function Cancel() {
document.getElementById("modalDeleteForm").style.display = "none";      

   }

   function getRoleData(){
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    
   let UserRole =  localStorage.getItem("Role");
  
   const body ={
    
    role:UserRole
  
   }
   console.log(body);
  
  
    axios({          
       method: "POST", 
       url: `${BASE_URL}/Tc/GetTcloginUserRole`,      
       //url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
      
       }) 
     
      }


   function getUserRole(){

    /**----getroleAction---- */

let Tcrole =  localStorage.getItem("loginUserRoleaction");
let roledata =  JSON.parse(Tcrole);
let role = roledata.map((e)=>e.roleAction);
console.log(role);

let roles = role.toString();
let Add = roles.includes('Add')
console.log(Add)

let View = roles.includes('View')
console.log(View)

let Edit = roles.includes('Edit')
console.log(Edit)

let Delete = roles.includes('Delete')
console.log(Delete)
let empty = roles.includes('')
console.log(empty)

let roleid = localStorage.getItem('RoleId')
let id = roleid.includes('01')
console.log(id)

 /**----- Conditions--- **/

 
 if(id==true&&empty==true&&Add==false&&View==false&&Edit==false&&Delete==false)
 {
 setEdit(true);
 setDel(true);
 setDisplay(true); 
 document.getElementById('ActionData').style.display ="block";
 document.getElementById('TCtermsbtn').style.display ="block";
 document.getElementById('action-err').innerHTML = ''
 }

if(id==false&&empty==true&&Add==false&&View==false&&Edit==false&&Delete==false)
{
  setEdit(false);
  setDel(false);
  document.getElementById('TCtermsbtn').style.display ="none";
  document.getElementById('TCtable').style.display ="none";
  document.getElementById('inputs').style.display ="none";
  document.getElementById('pagination').style.display ="none";
  document.getElementById('action-err').innerHTML = 'No Task Assign'
}
if(Add==true&&View==true&&Edit==true&&Delete==true){
  setEdit(true);
  setDel(true);
  setDisplay(true); 
  document.getElementById('ActionData').style.display ="block";
  document.getElementById('TCtermsbtn').style.display ="block";
 
}

 
 if(Add==false&&View==true&&Edit==true&&Delete==true){
  setEdit(true);
  setDel(true);
  setDisplay(true); 
  document.getElementById('TCtermsbtn').style.display ="none";
  document.getElementById('inputs').style.display ="none";
}


if(View==true&&Add==false&&Edit==false&&Delete==false){
 
   setDisplay(false);
   document.getElementById('TCtermsbtn').style.display ="none";
   document.getElementById('inputs').style.display ="none";
   document.getElementById('ActionData').style.display ="none";

}


if( Add==true&&View==false&&Edit==false&&Delete==false){
  
  setDisplay(false);
  document.getElementById('ActionData').style.display ="none";
document.getElementById('TCtermsbtn').style.display ="block";
document.getElementById('TCtable').style.display ="none";
document.getElementById('pagination').style.display ="none";

}

 
if(Add==true&&Edit==true&&View==false&&Delete==false){
  setDel(false);
  setEdit(true);
  setDisplay(true);  
  document.getElementById('ActionData').style.display ="block";
document.getElementById('TCtermsbtn').style.display ="block";

}


if( Edit==true&&Add==false&&View==false&&Delete==false){

  setDel(false);
  document.getElementById('TCtermsbtn').style.display ="none";
  document.getElementById('inputs').style.display ="none";
 
   }

   if( Delete==true&&Add==false&&View==false&&Edit==false){
    setEdit(false); 
    document.getElementById('TCtermsbtn').style.display ="none";
    document.getElementById('inputs').style.display ="none";
   }
    

   if(Add==true&&View==true&&Edit==false&&Delete==false){
    setEdit(false);
    setDel(false);
    setDisplay(false); 
    document.getElementById('TCtermsbtn').style.display ="block";
    
    document.getElementById('ActionData').style.display ="none";
    
 }  
 if(Edit==true&&Delete==true&&Add==false&&View==false){
  document.getElementById('TCtermsbtn').style.display ="none";
  document.getElementById('inputs').style.display ="none";
  setEdit(true);
  setDel(true);
  setDisplay(true);     
}

if(Add==true&&Delete==true&&View==false&&Edit==false){
  setDel(true);
  setEdit(false); 
  setDisplay(true);  
  document.getElementById('ActionData').style.display ="block";
  document.getElementById('TCtermsbtn').style.display ="block";
  
}
if(Add==true&&View==false&&Edit==true&&Delete==true){
  setEdit(true);
  setDel(true);
  setDisplay(true); 
  document.getElementById('ActionData').style.display ="block";
  document.getElementById('TCtermsbtn').style.display ="block";

}

if( Add==false&&View==true&&Edit==false&&Delete==true){
  setEdit(false); 
  setDel(true); 
  document.getElementById('TCtermsbtn').style.display ="none";
  document.getElementById('inputs').style.display ="none";
   }
if( Add==false&&View==true&&Edit==true&&Delete==false){
    setEdit(true); 
    setDel(false); 
    document.getElementById('TCtermsbtn').style.display ="none";
    document.getElementById('inputs').style.display ="none";
     }
    
if( Add==true&&View==true&&Edit==true&&Delete==false){
        setEdit(true); 
        setDel(false); 
        document.getElementById('TCtermsbtn').style.display ="block";
     }
if( Add==true&&View==true&&Edit==false&&Delete==true){
          setEdit(false); 
          setDel(true); 
          document.getElementById('TCtermsbtn').style.display ="block";
  }

 if(Add==false&&View==false&&Edit==true&&Delete==true){
            setEdit(true);
            setDel(true);
            setDisplay(true); 
            document.getElementById('TCtermsbtn').style.display ="none";
            document.getElementById('inputs').style.display ="none";
            
}

  

   }


   function GetTermsList(){
     
        fetch('https://localhost:44312/Api/Tc/GetTcTermsListContent', {
         
        method:'GET',
      
          headers : {
      
            "Content-type": "application/json",
      
            "Accept": "application/json",
         
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          },
      
    
    }).then(response => response.json())
    .then(data => {
    console.log("Data",data)   
       setList(data)   
      localStorage.setItem("listItem", JSON.stringify(data));
     
    });   
    }

    const LEFT_PAGE = "LEFT";
    const RIGHT_PAGE = "RIGHT";
    const range = (from, to, step = 1) => {
      let i = from;
      const range = [];
    
      while (i <= to) {
        range.push(i);
        i += step;
      }
    
      return range;
    };
    
    const [currentPage, setCurrentPage] = useState(1);
    
    let data =   localStorage.getItem("TermsData") 
    let transdata =  JSON.parse(data);
    let NUM_OF_RECORDS = transdata.length;
    let LIMIT = 5;
    
    const onPageChanged = useCallback(
    
      (event, page) => {
        event.preventDefault();
        setCurrentPage(page);
      },
      [setCurrentPage]
      
    );
    
    
    const currentData = transdata.slice(
      (currentPage - 1) * LIMIT,
      (currentPage - 1) * LIMIT + LIMIT
    );
    
    const Paginations = (props) => {
      const {
        totalRecords,
        pageLimit,
        pageNeighbours,
        onPageChanged,
        currentPage
      } = props;
      const [totalPages, setTotalPages] = useState(0);
      useEffect(() => {
        setTotalPages(Math.ceil(totalRecords / pageLimit));
      }, [setTotalPages]);
    
      const fetchPageNumbers = () => {
        const totalNumbers = pageNeighbours * 2 + 3;
        
        const totalBlocks = totalNumbers + 2;
     
    
        if (totalPages > totalBlocks) {
          const startPage = Math.max(2, currentPage - pageNeighbours);
          const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
    
          let pages = range(startPage, endPage);
    
          const hasLeftSpill = startPage > 2;
          const hasRightSpill = totalPages - endPage > 1;
          const spillOffset = totalNumbers - (pages.length + 1);
    
          switch (true) {
            case hasLeftSpill && !hasRightSpill: {
              const extraPages = range(startPage - spillOffset, startPage - 1);
              pages = [LEFT_PAGE, ...extraPages, ...pages];
              break;
            }
            case hasLeftSpill && hasRightSpill:
            default: {
              pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
              break;
            }
          }
          return [1, ...pages, totalPages];
        }
        return range(1, totalPages);
      };
    
    
      const pages = fetchPageNumbers() || [];
      return (
        <nav aria-label="Countries Pagination">
          <ul className="pagination">
            {pages.map((page, index) => {
              if (page === LEFT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <a
                      href="/"
                      className="page-link"
                      aria-label="Previous"
                      onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                );
    
              if (page === RIGHT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <a
                      className="page-link"
                      href="/"
                      aria-label="Next"
                      onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 3)}
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                );
    
              return (
                <li
                  key={index}
                  className={`Tc-page-item${currentPage === page ? " active" : ""}`}
                >
                  <a
                    className="page-link"
                    href="/"
                    onClick={(e) => onPageChanged(e, page)}
                  >
                    {page}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>
      );
    }; 

return(
    <>
 
        <div className='TC-addmain'>
           
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Tcsection'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span> Terms & Conditions </span>
    </div>
    </div>
    <div className='Tc-TermMain' id='Tc-sectionMain'>   
    <span id='action-err'></span>   
   <div id='inputs'> 

<input  placeholder="Main Heading" id='headinputA' className='termsInput'onKeyUp={handlechange}></input>&nbsp;&nbsp;&nbsp;

<input  placeholder="Sub Heading" id='headinputB' className='termsInput'></input>&nbsp;&nbsp;&nbsp;

{/* <p>ListContent</p> */}

<input id='listInput'  placeholder="ListContent" className='termsInput'></input>&nbsp;&nbsp;<i class="fa-solid fa-circle-plus"  onClick={myFunction} style={{ cursor: 'pointer' }}></i><br></br>

{/* <button id ='Tc-termsbutton' onClick={myFunction}><i class="fa-solid fa-circle-plus"></i></button> */}

{/* <input id='listInputA' placeholder=""></input> <button id ='Tc-buttonD' onClick={myFunctionA}>Add</button> */}
<span id='HeadingAError' className='Tcadduser-error'></span>
<ul id='myList'>
</ul>

<textarea placeholder="Content" id='contentinput'  onKeyUp={handlechange} ></textarea>
<span id='HeadingBError' className='Tcadduser-error'></span><br></br>
<button class=" AddBtn" id='TCtermsbtn'><span onClick={AddTcTermsCondition}><i className="fa-regular fa-square-plus"></i></span><span onClick={AddTcTermsCondition} >ADD </span></button>
{/* <button id='TCtermsbtn' onClick={AddTcTermsCondition} >ADD</button> */}
</div> 

    </div>

 {/* --- Terms&condition table--- */}

    <div className='TCtermstable' id='TCtable'>
     <div class="TC-table_responsive">
     {
  !paginatedPosts ? (<span style={{display:'flex',justifyContent:'center'}}>No Data Found</span>):(
       <table  className='TC-tblhead' id='TcTable'> 
    <thead>
   <tr>
<th>Main Heading</th>
<th>Sub Heading</th>
<th>MainContent</th>
<th>ListContent</th>
<th id='ActionData'>Action</th>

</tr>
</thead>
<tbody>

{currentData.map((e)=>
{
 
return<tr id='row'>

<td style={{whiteSpace:"nowrap"}}>{e.heading4}</td>

<td style={{whiteSpace:"nowrap"}}>{e.heading5}</td> 
<td><div style={{inlineSize:"450px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.mainContent}</div></td>
{/* <td>{e.mainContent}</td> */}


<td><div style={{inlineSize:"350px",overflowWrap:"break-word",wordWrap:"break-word"}}>{list.map((item) => ( 
       <ul>{e.id==item.id?<li>{item.listContent}</li>:null}</ul>       
        ))} </div></td>  
      
      
 {/* <td>{e.listContent.split("*")?e.listContent.split("*").map(list=><ul><li key={e.id}>{e.listContent.split("*")}</li></ul>) : ""}</td> */}
 
 {/* <td>{e.listContent ? e.listContent.replace(/\n/g, <br />) : ""}</td>  */}

{display?<td style={{whiteSpace:"nowrap"}}>{edit?<i id='Tcediticon'  onClick={()=>getEditContent(e.id)} className="fa-regular fa-pen-to-square"></i>:null}&nbsp;&nbsp;&nbsp;

{del?<i className="fa-solid fa-trash" id='Tcdelicon' onClick={()=>ConfirmDelete(e.id)} ></i>:null}<span id='action-err'></span></td>:null}

</tr>

}
)}
</tbody>

</table>
)}


     </div>
  </div>
<br></br>

  <div id='pagination'>
  {
  !paginatedPosts ? (""):(
  <nav id='Tc-Pag'>
  
  {transdata.length<=5 ? null:  <ul className='Tc-pagination'>
     
          <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={3}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          />

    </ul>}
  </nav>
  )}
  </div>
  <br></br>


  <div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Terms & condition&nbsp; <span style={{color:"blue"}}>Added</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
             
          </section> 
            
          
    </div>
  </div>
</div>

<div className='TCpopfade' id='error-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p>Terms & condition&nbsp; Added </p>
      <h6 class="notif-title">Failed !&nbsp;<i class="fa-solid fa-thumbs-down"style={{fontSize:'25px'}}></i></h6>
    
   </section>
    </div>
  </div>
</div>


<div className='TCpopfade' id='edit-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Terms&condition <span style={{color:"blue"}}>Updated</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          
          </section> 
            
          
    </div>

  </div>
</div>

<div className='TCpopfade' id='del-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Terms & condition <span style={{color:"red"}}>Deleted</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>
 {/* --- Edit Form --- */}

  <form id="contentreset" >
<div className='TCpopfade' id="tcContenteditForm">
  <div className="modal-dialog" role="document">
    <div className="modal-content" id="modal-Popup">
      <div className="modal-header text-center">
      <h4 className="modal-title w-100 font-weight-bold" >Edit Content</h4>
        <button type="button" className="close"onClick={closeContentEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      
      {content.map((e)=>
{
return<div>
   <div className="modal-body mx-3">
   <div className="md-form mb-3">
   <label>Main Heading</label>
                  <input id='editInputA'  defaultValue={e.heading4} onKeyUp={handleTermschange}/>
                  <span id='UpdateSecErrA' className='TcProfile-error'></span>
                  </div>
                  <div className="md-form mb-3">
                  <label>Sub Heading</label>
                  <input id='editInputB'  defaultValue={e.heading5} />
                  <span id='UpdateSecErrB' className='TcProfile-error'></span>
                  </div>
                  <div className="md-form mb-3">
                  <label>Main Content</label>
                  <textarea id='editInputC'  defaultValue={e.mainContent}   onKeyUp={handleTermschange}/>
                  <span id='UpdateSecErrC' className='TcProfile-error'></span>
                  </div>
                  <div className="md-form mb-3">
                  <label>List Content</label>
                  <textarea id='editInputD'  defaultValue={e.listContent} />
                  <span id='UpdateSecErrD' className='TcProfile-error'></span>
                  </div>
    
                </div>
                  <div className="modal-footer d-flex justify-content-center">
                  <button className='TC-adduser-button' onClick={()=>updateContent(e.id)}>Update</button>
      
                  </div>
 </div>
 }
 )}
           

    </div>
  </div>
</div>
</form>

 {/* --- Delete form --- */}

<div className="TCpopfade" id="modalDeleteForm" tabindex="-1" role="dialog">
{delDetail.map((e)=>
{
return<div>
  <div className="modal-dialog" role="document">
    <div className="modal-contentA">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Alert</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>
   <div className="modal-body mx-3">

        <div className="md-form mb-3">
            <div className='text-center'>
          <h5>Are you sure want to&nbsp;<span style={{color:"red"}}>Delete?</span></h5>
       
          </div>
        </div>
   </div>

      <div className="modal-footer d-flex justify-content-center">
       <button className='TC-logout-button'onClick={()=>delContent(e.id)}  type='submit'>Confirm</button>
        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<button className='TC-logout-button' onClick={Cancel} type='submit'>Cancel</button>
      </div>
      </form>
      
    </div>
  </div>
  </div>
  }
 )}
     </div>


      {pop? <div id="Loader">

<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null} 
 
    </div>

    </>
)
}

export default TcTermsMain;